// extracted by mini-css-extract-plugin
module.exports = {"search-button-container":"header-csr_search-button-container__7J_Cd","search-dropdown-container":"header-csr_search-dropdown-container__al_eH"};